<template>
  <header class="flex flex-wrap justify-between items-center px-2 bg-white border-b" :class="isMobile() ? 'border-section_border' : ''">
    <p>
      <a :href="maas_top_url()">
        <img :src="getLogo()" alt="$t('tour_mae_maas')" class="header-logo" />
      </a>
    </p>
  </header>
</template>

<script>
import Constants from "../../constants";

export default {
  name: 'TheHeader',
  methods: {
    maas_top_url: function () {
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID) {
        return Constants.LINK_BASE_URL + '/'
      } else {
        return Constants.LINK_BASE_URL + '/' + areaId
      }
    },
    getLogo: function () {
      const areaId = this.$store.getters['user/getAreaId'] || Constants.DEFAULT_AREA_ID
      const logo = Constants.MX1_ORAGA_LOGO_LIST[areaId]
      return require('@/assets/images/' + logo)
    },
    isMobile() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("iphone") != -1 || userAgent.indexOf("android") != -1) {
        return true;
      } else {
        return false;
      }
    }
  }
}
</script>
